var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 0.666748C3.15942 0.666748 2.33268 1.49349 2.33268 2.50008V9.83342C2.33268 10.84 3.15942 11.6667 4.16602 11.6667H9.49935C10.5059 11.6667 11.3327 10.84 11.3327 9.83342V2.50008C11.3327 1.49349 10.5059 0.666748 9.49935 0.666748H4.16602ZM4.16602 1.66675H9.49935C9.96542 1.66675 10.3327 2.03401 10.3327 2.50008V9.83342C10.3327 10.2995 9.96542 10.6667 9.49935 10.6667H4.16602C3.69994 10.6667 3.33268 10.2995 3.33268 9.83342V2.50008C3.33268 2.03401 3.69994 1.66675 4.16602 1.66675ZM1.66602 2.33341L1.25977 2.60425C0.888766 2.85158 0.666016 3.26796 0.666016 3.71362V10.1667C0.666016 11.9157 2.08368 13.3334 3.83268 13.3334H8.28581C8.73181 13.3334 9.14818 13.1107 9.39518 12.7397L9.66602 12.3334H3.83268C2.63602 12.3334 1.66602 11.3634 1.66602 10.1667V2.33341Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.792fefc6bbec381a7ac6974863cfd983.svg";
export { ForwardRef as ReactComponent };